import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";
import { downloadBinaryFile, downloadFromBase64 } from "../../utils";

export class _BotsAdminStore {

  obs = observable({
    tabelaBots: [] as any,
    currentPageBot: 1 as number,
    length_bots: 0 as number
  })

  async handleGetBots(params) {
    try {
      let resp = await api_adm.post(`/api/admin/bots/index`, params);

      this.obs.tabelaBots = [];
      this.obs.tabelaBots = resp.data.itens
      this.obs.length_bots = 0;
      this.obs.length_bots = resp.data.count

    } catch (ex) {
      toast.error("Erro ao carregar Bots!", {});
    }
  }

  async handleRestartBots(params) {

    try {

      let resp = await api.post(`/api/bots/restart`, params);

      if (resp.data.length == 0) {

        toast.success("Reiniciada a(s) tarefa(s)!", {});

      }

      return resp.data

    } catch (ex) {
      toast.error("Erro ao carregar Bots!", {});
    }

    return []

  }

  baixarOuErro = (condicao, acao) => {
    if (condicao) acao();
    else toast.error("Não foi possível baixar o arquivo!");
  };

  async handleDownloadFile(tipo, row) {

    try {

      const tiposIgnorados = [
        "caixapostal", "calculo", "contestacao", "manifestacao",
        "solicitacao_sefa", "xml_integration", "dec_ler", "dec_download"
      ];

      if (tiposIgnorados.includes(tipo)) return;

      if (["caixa", "tst", "receita", "sefa"].includes(tipo)) {

        const resp = await api.post(`/api/cnds/download`, { id: row.cnds_id });

        this.baixarOuErro(resp.status === 200 && resp.data.file, () =>

          downloadFromBase64(resp.data.file, "pdf", `${row.cnpj}_${tipo}.pdf`)

        );

      } else if (tipo == "fgts_digital") {

        for (const subtipo of ["guia", "relatorio"]) {

          const resp = await api.post(`/api/fgtsdigital/download`, {
            id: row.fgtsdigital_id,
            tipo: subtipo
          });

          this.baixarOuErro(resp.status === 200 && resp.data.file, () =>

            downloadFromBase64(resp.data.file, "pdf", `${row.cnpj}_${subtipo}.pdf`)

          );

        }

      } else if (tipo == "parauapebas") {

        const resp = await api.get(`/api/parauapebas/arquivos/${row.paraupebas_id}`);

        if (resp.status === 200 && resp.data.length) {

          for (const file of resp.data) {

            const fileResp = await api.get(`/api/parauapebas/download/${file.download}`);

            this.baixarOuErro(fileResp.status === 200 && fileResp.data.file, () =>

              downloadFromBase64(fileResp.data.file, "zip", `${row.cnpj}_${file.download}`)

            );

          }

        } else {

          toast.warning('Sem arquivos Disponíveis.');

        }

      } else if (["pgdas", "gera_das"].includes(tipo)) {

        const resp = await api.post(`/api/consulta-arquivo-pgdas-tarefa`, { uuid: row.pgdas_id });

        if (resp.status === 200 && resp.data.length) {

          for (const arquivo of resp.data) {

            const fileResp = await api.post(`/api/download-one-pgdas`, {
              uuid: row.pgdas_id,
              file_id: arquivo.id
            });

            downloadFromBase64(fileResp.data.base64, "pdf", `${row.cnpj}_${arquivo.nome}`);
          }

        } else {

          toast.error("Não foi possível baixar o arquivo!");

        }

      } else if (tipo == "relatorio") {

        const resp = await api.post(`/api/relatorio/task/download`,
          { id: row.relatorio_id, format: row.format },
          { responseType: 'blob' }
        );

        this.baixarOuErro((resp.status === 200 && resp.data.type !== 'application/json'), () =>

          downloadBinaryFile(resp.data, `${row.cnpj}_RELATORIO.${row.format}`)

        );

      } else if (tipo == "download_sefa") {

        let resp = await api.post(`/api/sefa/download/zip`,
          { nome: row._id, files: row.arquivos },
          { responseType: 'blob' }
        );

        this.baixarOuErro((resp.status === 200 && resp.data.type !== 'application/json'), () =>

          downloadBinaryFile(resp.data, `${row.cnpj}_${row._id}.zip`)

        );

      } else if (tipo == "sitfis") {

        const resp = await api.post(`/api/sitfis/download`, { id: row.sitfis_id });

        this.baixarOuErro(resp.status === 200 && resp.data.file, () =>

          downloadFromBase64(resp.data.file, "pdf", `${row.cnpj}_SITFIS.pdf`)

        );

      } else if (tipo == "sped") {

        const resp = await api.get(`/api/sped/task/download/${row.sped_id}`);

        this.baixarOuErro(resp.status === 200 && resp.data.file, () =>

          downloadFromBase64(resp.data.file, "txt", `${row.cnpj}-SPED.txt`)

        );

      } else if (tipo == "dae_avulso") {

        const resp = await api.post(`/api/dae-avulso/download`, {task_id: row.task_id});

        this.baixarOuErro(resp.status === 200 && resp.data.base64, () =>

          downloadFromBase64(resp.data.base64, "pdf", `${row.cnpj}_DAE-AVULSO.pdf`)

        );

      } else if (tipo == "dei") {

        let receitas = row.receitas.map(x => {

          return Object.entries(x).map(([campo, valor]) => {
      
            return campo
      
          })
    
        })

        const resp = await api.post(`/api/dae-avulso/download`, 
          {task_id: row.task_id, receitas: receitas},
          { responseType: 'blob' }
        );

        this.baixarOuErro((resp.status === 200 && resp.data.type !== 'application/json'), () =>

          downloadBinaryFile(resp.data, `${row.cnpj}_${row._id}.zip`)

        );

      } else if (tipo == "tarefas_danfe") {

        const resp = await api.get(`/api/danfe-task-download/${row._id}`,
          { responseType: "blob" }
        );

        this.baixarOuErro((resp.status === 200 && resp.data.type !== 'application/json'), () =>

          downloadBinaryFile(resp.data, `${row.cnpj}_${row._id}.zip`)

        );

      } else {

        toast.error(`Tipo de download não suportado: ${tipo}`);

      }

    } catch (err) {

      toast.error("Não foi possível baixar o arquivo, tente novamente mais tarde!");

    }

  }

  async handleGetAllBots(baseParams) {

    const all_tasks = [];
    const limit = 500;

    let page = 1;

    while (true) {

      try {

        const params = {
          ...baseParams,
          page,
          limit
        };

        let resp = await api_adm.post(`/api/admin/bots/index`, params);

        const itens = resp?.data?.itens ?? [];

        if (itens.length === 0) break;

        for (const item of itens) {

          all_tasks.push({
            id: item._id,
            tipo: baseParams.tipo,
            status: item.status
          });

        }

        if (itens.length < limit) break;

        page++;

      } catch (error) {

        toast.error("Erro ao consultar todas tarefas, tente novamente mais tarde.");
        break;

      }

    }

    return all_tasks;

  }

}

export const BotsAdminStore = new _BotsAdminStore();
